export const WorkflowStatus = Object.freeze({
  DRAFT: 'draft',
  REVIEW: 'review',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  DISCARDED: 'discard',
  PUBLISHED: 'published',
});
